import { render, staticRenderFns } from "./CreateBio.vue?vue&type=template&id=cd7f4662&"
import script from "./CreateBio.vue?vue&type=script&lang=js&"
export * from "./CreateBio.vue?vue&type=script&lang=js&"
import style0 from "./CreateBio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports